function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import equals from 'ramda/src/equals';
import { stateGo } from 'redux-ui-router';
import i18n from 'invision-core/src/components/i18n/i18n';
import { CODES } from 'invision-core/src/components/metadata/codes/codes.constants';
import { fetchCodeTypes } from 'invision-core/src/components/metadata/codes/codes.actions';
import { MetadataCodeLoadedSelector } from 'invision-core/src/components/metadata/codes/codes.selectors';
import { NON_BULK_SERVICE_STATUSES } from 'invision-core/src/constants/status.constants';
import CustomerLocaleKeys from '../../../../../../locales/keys';
import { setSelectedServiceIdentifier, suspendOrResumeServices } from '../../../../../../reducers/actions/services.actions';
import { CurrentCustomerIdSelector, IsPIIDataAccessEnabledSelector } from '../../../../../../reducers/selectors/customer.selectors';
import { HasSuspendResumePermissionSelector, IsServiceLifeCycleStatusUpdatableSelector, IsSuspendingOrResumingServicesSelector, ResumeServiceReasonCodesSelector, SuspendServiceReasonCodesSelector } from '../../../../../../reducers/selectors/services.selectors';
import { SelectedServiceIdentifierSelector } from '../../../../../../reducers/selectors/selected.service.details.selectors';
import { IsFetchingWidgetDataSelector } from '../../../../../../reducers/selectors/dashboard.selectors';
import { getSuspensionTypeByCode } from '../../../../../../reducers/selectors/services.list.selectors.helper';
import { RESUME_SERVICES_REDIRECT, SUSPEND_SERVICES_REDIRECT, SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE } from '../../../../../../reactRoutes';
var ServiceThumbnailController = /*#__PURE__*/function () {
  function ServiceThumbnailController($ngRedux, $timeout, uiNotificationService) {
    _classCallCheck(this, ServiceThumbnailController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      $timeout: $timeout,
      CustomerLocaleKeys: CustomerLocaleKeys,
      NON_BULK_SERVICE_STATUSES: NON_BULK_SERVICE_STATUSES,
      onCloseUpdateFriendlyNameModal: this.onCloseUpdateFriendlyNameModal.bind(this),
      onMoreMenuItemSelected: this.onMoreMenuItemSelected.bind(this),
      onSubmitUpdateFriendlyName: this.onSubmitUpdateFriendlyName.bind(this),
      onCloseUpdateServiceLifeCycleStatusModal: this.onCloseUpdateServiceLifeCycleStatusModal.bind(this),
      uiNotificationService: uiNotificationService
    });
  }
  return _createClass(ServiceThumbnailController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var controllerActions = {
        fetchCodeTypes: fetchCodeTypes,
        setSelectedServiceIdentifier: setSelectedServiceIdentifier,
        stateGo: stateGo,
        suspendOrResumeServices: suspendOrResumeServices
      };
      var mapStateToTarget = function mapStateToTarget(store) {
        return {
          currentCustomerId: CurrentCustomerIdSelector(store),
          hasSuspendResumeAccess: HasSuspendResumePermissionSelector(store),
          isFetchingWidgetData: IsFetchingWidgetDataSelector(store),
          isPIIDataAccessEnabled: IsPIIDataAccessEnabledSelector(store),
          isServiceLifecycleCodesLoaded: MetadataCodeLoadedSelector(CODES.ServiceLifeCycleStatus, store),
          isServiceLifeCycleStatusUpdatable: IsServiceLifeCycleStatusUpdatableSelector(store),
          isServiceReasonCodeLoaded: MetadataCodeLoadedSelector(CODES.ReasonCodes, store),
          isSuspendingOrResuming: IsSuspendingOrResumingServicesSelector(store),
          resumeServiceReasonCodes: ResumeServiceReasonCodesSelector(store),
          selectedServiceIdentifier: SelectedServiceIdentifierSelector(store),
          suspendServiceReasonCodes: SuspendServiceReasonCodesSelector(store)
        };
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
      this.updateFriendlyNameModalConfig = {
        onRegisterApi: function onRegisterApi(_ref) {
          var api = _ref.api;
          _this.updateFriendlyNameModalConfigApi = api;
        }
      };
      this.updateServiceLifeCycleStatusConfig = {
        onRegisterApi: function onRegisterApi(_ref2) {
          var api = _ref2.api;
          _this.updateServiceLifeCycleStatusConfigApi = api;
        }
      };
      if (!this.state.isServiceLifecycleCodesLoaded) {
        this.actions.fetchCodeTypes(CODES.ServiceLifeCycleStatus);
      }
      if (!this.state.isServiceReasonCodeLoaded) {
        this.actions.fetchCodeTypes(CODES.ReasonCodes);
      }
      if (this.service) {
        this.moreMenuItems = this.getMoreMenuItems();
        this.suspendType = getSuspensionTypeByCode(this.service.SuspendTypeCode);
      }
    }
  }, {
    key: "$onChanges",
    value: function $onChanges(changesObj) {
      if (this.state && changesObj.service && !equals(changesObj.service.currentValue, changesObj.service.previousValue)) {
        this.moreMenuItems = this.getMoreMenuItems();
        this.suspendType = getSuspensionTypeByCode(this.service.SuspendTypeCode);
      }
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "onMoreMenuItemSelected",
    value: function onMoreMenuItemSelected(_ref3) {
      var _this2 = this;
      var itemProps = _ref3.item;
      switch (itemProps.id) {
        case CustomerLocaleKeys.MANAGE_ADD_ONS:
          if (!itemProps.isLocked) {
            var _this$service$Service = this.service.ServiceAttributeValues.find(function (attr) {
                return attr.Value === _this2.service.ServiceIdentifier;
              }),
              ServiceId = _this$service$Service.ServiceId,
              ServiceInstanceId = _this$service$Service.ServiceInstanceId,
              ServiceAttributeId = _this$service$Service.ServiceAttributeId;
            this.actions.stateGo(SERVICE_ADD_ON_PRODUCTS_ORDERING_PAGE_ROUTE, {
              customerId: this.state.currentCustomerId,
              serviceIdentifierValue: this.service.ServiceIdentifier,
              serviceId: ServiceId,
              serviceAttributeId: ServiceAttributeId
            });
          }
          break;
        case CustomerLocaleKeys.CUSTOMER_DASHBOARD.FRIENDLY_NAME.MODAL_TITLE:
          this.selectedService = {
            Value: this.service.ServiceIdentifier,
            FriendlyName: this.service.ServiceName
          };
          this.showUpdateFriendlyNameModal = true;
          this.$timeout(function () {
            _this2.updateFriendlyNameModalConfigApi.open();
          });
          break;
        case CustomerLocaleKeys.SUSPEND_SERVICE:
        case CustomerLocaleKeys.RESUME_SERVICE:
          this.openSuspendResumeServiceModal();
          break;
        case CustomerLocaleKeys.UPDATE_SERVICE_LIFECYCLE_STATUS:
          this.showUpdateServiceLifeCycleStatusModal = true;
          this.$timeout(function () {
            _this2.updateServiceLifeCycleStatusConfigApi.open();
          });
          break;
        default:
          break;
      }
    }
  }, {
    key: "onCloseUpdateFriendlyNameModal",
    value: function onCloseUpdateFriendlyNameModal() {
      this.showUpdateFriendlyNameModal = false;
      this.updateFriendlyNameModalConfigApi.close();
    }
  }, {
    key: "onSubmitUpdateFriendlyName",
    value: function onSubmitUpdateFriendlyName() {
      this.refreshServices && this.refreshServices();
      this.onCloseUpdateFriendlyNameModal();
    }
  }, {
    key: "openSuspendResumeServiceModal",
    value: function openSuspendResumeServiceModal() {
      if (this.service.ServiceStatus === NON_BULK_SERVICE_STATUSES.ACTIVE) {
        var _this$service$Service2, _this$service;
        this.actions.stateGo(SUSPEND_SERVICES_REDIRECT, {
          customerId: this.state.currentCustomerId,
          serviceIdentifier: (_this$service$Service2 = (_this$service = this.service) === null || _this$service === void 0 ? void 0 : _this$service.ServiceIdentifier) !== null && _this$service$Service2 !== void 0 ? _this$service$Service2 : null
        });
      } else {
        var _this$service$Service3, _this$service2;
        this.actions.stateGo(RESUME_SERVICES_REDIRECT, {
          customerId: this.state.currentCustomerId,
          serviceIdentifier: (_this$service$Service3 = (_this$service2 = this.service) === null || _this$service2 === void 0 ? void 0 : _this$service2.ServiceIdentifier) !== null && _this$service$Service3 !== void 0 ? _this$service$Service3 : null
        });
      }
    }
  }, {
    key: "onCloseUpdateServiceLifeCycleStatusModal",
    value: function onCloseUpdateServiceLifeCycleStatusModal() {
      this.showUpdateServiceLifeCycleStatusModal = false;
      this.updateServiceLifeCycleStatusConfigApi.close();
    }
  }, {
    key: "onSubmitUpdateServiceLifeCycleStatus",
    value: function onSubmitUpdateServiceLifeCycleStatus() {
      this.onCloseUpdateServiceLifeCycleStatusModal();
    }
  }, {
    key: "getMoreMenuItems",
    value: function getMoreMenuItems() {
      var moreMenuItems = [];
      var isServiceSuspended = this.service.ServiceStatus === NON_BULK_SERVICE_STATUSES.SUSPENDED;
      var isServicePendingSuspension = this.service.ServiceStatus === NON_BULK_SERVICE_STATUSES.PENDING_SUSPENSION;
      if (this.state.isPIIDataAccessEnabled) {
        moreMenuItems.push({
          id: CustomerLocaleKeys.MANAGE_ADD_ONS,
          title: i18n.translate(CustomerLocaleKeys.MANAGE_ADD_ONS),
          isLocked: isServiceSuspended,
          disabled: isServiceSuspended
        });
      }
      moreMenuItems.push({
        id: CustomerLocaleKeys.CUSTOMER_DASHBOARD.FRIENDLY_NAME.MODAL_TITLE,
        title: i18n.translate(CustomerLocaleKeys.CUSTOMER_DASHBOARD.FRIENDLY_NAME.MODAL_TITLE)
      });
      if (this.state.isServiceLifeCycleStatusUpdatable) {
        if (this.service.ServiceStatus === NON_BULK_SERVICE_STATUSES.ACTIVE) {
          moreMenuItems.push({
            id: CustomerLocaleKeys.UPDATE_SERVICE_LIFECYCLE_STATUS,
            title: i18n.translate(CustomerLocaleKeys.UPDATE_SERVICE_LIFECYCLE_STATUS)
          });
        }
      }
      if (this.state.hasSuspendResumeAccess) {
        if (this.service.ServiceStatus === NON_BULK_SERVICE_STATUSES.ACTIVE) {
          moreMenuItems.push({
            id: CustomerLocaleKeys.SUSPEND_SERVICE,
            title: i18n.translate(CustomerLocaleKeys.SUSPEND_SERVICE)
          });
        }
        if (isServiceSuspended || isServicePendingSuspension) {
          moreMenuItems.push({
            id: CustomerLocaleKeys.RESUME_SERVICE,
            title: i18n.translate(CustomerLocaleKeys.RESUME_SERVICE)
          });
        }
      }
      return moreMenuItems;
    }
  }]);
}();
export default {
  bindings: {
    refreshConvergentBillerDetails: '&?',
    refreshServices: '&?',
    service: '<'
  },
  template: require('./service.thumbnail.html'),
  controller: ServiceThumbnailController
};